import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    console.log('ContactFormToggleController connected')
  }

  toggle() {
    console.log('Toggle method called')

    const searchSection = document.getElementById('contact_search_section')
    const formSection = document.getElementById('contact_form_section')
    const toggleBtn = document.getElementById('toggle_create_contact')

    console.log('Elements found:', {
      searchSection: !!searchSection,
      formSection: !!formSection,
      toggleBtn: !!toggleBtn,
    })

    if (formSection.classList.contains('hidden')) {
      console.log('Showing form section')
      searchSection.classList.add('hidden')
      formSection.classList.remove('hidden')
      toggleBtn.innerHTML =
        '<svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke-width="1.5" stroke="currentColor"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg> Voltar à Busca'
    } else {
      console.log('Showing search section')
      searchSection.classList.remove('hidden')
      formSection.classList.add('hidden')
      toggleBtn.innerHTML =
        '<svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke-width="1.5" stroke="currentColor"><path d="M12 4.5v15m7.5-7.5h-15"/></svg> Criar Novo Contato'
    }
  }
}
